var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrayLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292467 9.04011C-0.0980568 8.64959 -0.0980568 8.01643 0.292467 7.6259L6.65643 1.26194C7.04695 0.871416 7.68012 0.871416 8.07064 1.26194C8.46117 1.65246 8.46117 2.28563 8.07064 2.67615L2.41379 8.33301L8.07064 13.9899C8.46117 14.3804 8.46117 15.0136 8.07064 15.4041C7.68012 15.7946 7.04695 15.7946 6.65643 15.4041L0.292467 9.04011ZM21.8691 9.33301H0.999575V7.33301H21.8691V9.33301Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrayLeft);
export default __webpack_public_path__ + "static/media/arrow-gray-left.86d6f0ef7d983b45cd67c14ec942439b.svg";
export { ForwardRef as ReactComponent };